/**
 * Shared constants for HTTP interceptor exclusion patterns
 */

/**
 * Pattern to match GET requests to the user endpoint with JWT token parameter.
 * This endpoint is used by view-as functionality to retrieve user tokens for impersonation.
 *
 * Must be excluded from both 403 and 404 global interceptors to allow the ViewAsWidget
 * component to display user-friendly error messages instead of triggering:
 * - 403: Logout redirect
 * - 404: Not found page redirect
 *
 * @example
 * // Matches URLs like:
 * // /users/123?includeJwtToken=true
 * // /users/user@example.com?includeJwtToken=true
 * // /users/123?foo=bar&includeJwtToken=true
 */
export const GET_USER_WITH_JWT_PATTERN = /\/users\/[^\/]+\?.*includeJwtToken=true(&|$)/i

/**
 * Pattern to match GET requests to the user email lookup endpoint.
 * This endpoint is used by view-as functionality to resolve an email address to a user ID
 * before retrieving tokens for impersonation.
 *
 * Must be excluded from 404 global interceptor to allow the ViewAsWidget component to
 * display user-friendly error messages instead of triggering not found page redirect.
 *
 * Note: This endpoint does not need 403 exclusion as it only returns user IDs,
 * not sensitive token data.
 *
 * Pattern uses:
 * - [^\/]+ to match one or more non-slash characters (the email)
 * - $ anchor to ensure path ends after email (no query params or additional path segments)
 *
 * @example
 * // Matches URLs like:
 * // /users/email/test@example.com
 * // /users/email/admin@flosports.tv
 *
 * // Does NOT match:
 * // /users/email/test@example.com/something
 * // /users/email/test@example.com?param=value
 */
export const GET_USER_BY_EMAIL_PATTERN = /\/users\/email\/[^\/]+$/i
